import type { ReactNode } from "react";
import { Card } from "../../lib/ui.js";

/** One block of the Business settings page: a titled card with an optional one-line explanation. */
export function SectionCard({ title, description, children }: { title: string; description?: ReactNode; children: ReactNode }) {
  return (
    <Card>
      <h2 style={{ fontSize: 15, fontWeight: 700, margin: 0, color: "var(--rc-text)" }}>{title}</h2>
      {description && <p style={{ fontSize: 12.5, color: "var(--rc-text-muted)", margin: "4px 0 0", maxWidth: 640 }}>{description}</p>}
      <div style={{ marginTop: 14 }}>{children}</div>
    </Card>
  );
}

export const errorStyle: React.CSSProperties = { color: "var(--rc-danger)", fontSize: 12.5, margin: "8px 0 0" };
export const mutedStyle: React.CSSProperties = { color: "var(--rc-text-faint)", fontSize: 13 };
export const linkButtonStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  color: "var(--rc-link)",
  cursor: "pointer",
  padding: 0,
  fontSize: 13,
  fontWeight: 600,
};
export const thStyle: React.CSSProperties = {
  padding: "8px 10px",
  color: "var(--rc-text-muted)",
  fontSize: 12.5,
  fontWeight: 600,
  textAlign: "left",
  borderBottom: "1px solid var(--rc-border)",
};
export const tdStyle: React.CSSProperties = { padding: "8px 10px", borderBottom: "1px solid var(--rc-border)", color: "var(--rc-text)", fontSize: 13.5 };
